import { Modal, ModalDialog, ModalDialogProps, Stack } from 'react-bootstrap';
import { ReactNode, useRef } from 'react';

import Draggable from 'react-draggable';

interface IDialogProps {
    body?: string;
    bodyComponent?: ReactNode;
    cancelText?: string;
    closeButtonClassName?: string;
    confirmButtonClassName?: string;
    confirmText?: string;
    dialogClassName?: string;
    disableActions?: boolean;
    draggable?: boolean;
    dragHandleClassName?: string;
    handleClose?: () => void;
    handleConfirm?: () => void;
    isShowingModal?: boolean;
    isShowCancel?: boolean;
    leftFooterComponent?: ReactNode;
    resizable?: boolean;
    showBackdrop?: boolean;
    size?: 'sm' | 'lg' | 'xl' | undefined;
    title?: string;
}

export function DraggableModalDialog(props: ModalDialogProps) {
    const nodeRef = useRef(null);

    return (
        <Draggable handle=".modal-header" nodeRef={nodeRef}>
            <div ref={nodeRef} className="draggable-box">
                <ModalDialog {...props} />
            </div>
        </Draggable>
    );
}

export function DraggableHandle(props: { children: ReactNode; enabled?: boolean }) {
    if (!props.enabled) return <>{props.children}</>;

    return (
        <div
            className="drag-handle"
            title="Click to Drag"
            style={{
                cursor: 'grab',
            }}
        >
            {props.children}
        </div>
    );
}

export function CheckmateDialog(props: IDialogProps) {
    const showCancel: boolean = props.isShowCancel ?? true;

    return (
        <Modal
            dialogAs={props.draggable ? DraggableModalDialog : undefined}
            centered
            show={props.isShowingModal}
            dialogClassName={props.dialogClassName}
            size={props.size ?? 'sm'}
            
            backdrop={props.showBackdrop ?? false}
        >
            {props.title ? (
                <DraggableHandle enabled={props.draggable}>
                    <Modal.Header>
                        <Modal.Title>{props.title}</Modal.Title>
                        {props.draggable && <i className="fa-regular fa-grip-dots-vertical" />}
                    </Modal.Header>
                </DraggableHandle>
            ) : null}
            <Modal.Body>
                {props.body?.split('\n').map((text: string, i: number) => {
                    return (
                        <p key={i}>
                            {text}
                            <br />
                        </p>
                    );
                })}
                {props.bodyComponent && <div>{props.bodyComponent}</div>}
            </Modal.Body>
            <Modal.Footer>
                <Stack
                    direction="horizontal"
                    style={{
                        justifyContent: props.leftFooterComponent ? 'space-between' : 'flex-end',
                        width: '100%',
                    }}
                >
                    {props.leftFooterComponent && <>{props.leftFooterComponent}</>}
                    <div>
                        {props.handleConfirm && (
                            <button
                                className={props.confirmButtonClassName}
                                disabled={props.disableActions}
                                onClick={props.handleConfirm}
                            >
                                {props.confirmText ? props.confirmText : 'OK'}
                            </button>
                        )}
                        {props.handleClose && showCancel && (
                            <button
                                className={props.closeButtonClassName}
                                disabled={props.disableActions}
                                onClick={props.handleClose}
                            >
                                {props.cancelText ? props.cancelText : 'Cancel'}
                            </button>
                        )}
                    </div>
                </Stack>
            </Modal.Footer>
        </Modal>
    );
}
